'use client'

import { FC, PropsWithChildren } from 'react'
import { useOptimizelyObfuscation } from '@/hooks/useOptimizelyObfuscation'
import styles from './styles.module.scss'

interface Props {
  // An explicit boolean controls the blur directly; omitted means use the page's CMS marker.
  aboveFoldExperimentation?: boolean
}

export const OptimizelyObfuscationLayer: FC<PropsWithChildren<Props>> = ({
  children,
  aboveFoldExperimentation,
}) => {
  const { hidden, optimizelyConfigured } = useOptimizelyObfuscation(
    // In marker mode, keep consent waiting active; CSS decides whether the page blurs.
    // Defaulting to true here does not blur pages without an enabled CMS marker.
    aboveFoldExperimentation ?? true,
  )

  const obfuscationPending = hidden && !optimizelyConfigured
  // Marker mode defaults to no blur when :has() is unsupported or the page isn't enabled.
  const pendingFilter =
    aboveFoldExperimentation === undefined
      ? 'var(--optimizely-page-filter, none)'
      : 'blur(25px)'

  return (
    <div
      data-testid="main"
      id="main"
      className={styles.layer}
      style={{
        filter: obfuscationPending ? pendingFilter : 'none',
        transition: 'filter 150ms ease',
      }}
    >
      {children}
    </div>
  )
}
